/**
 * Front-end JavaScript for the back button block.
 * Handles the history.back() functionality.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function () {
    const backButtons = document.querySelectorAll(".wp-block-creatable-touch-back");

    backButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
            e.preventDefault();
            window.history.back();
        });
    });
});
